<script setup lang="ts">
import { computed } from 'vue'
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline'

const props = defineProps(['params'])
const row = computed(() => props.params?.data)

const contact = computed(() => row.value?.contact)
const company = computed(() => row.value?.company)

const displayText = computed(() => {
  if (contact.value) {
    return `${contact.value.firstname || ''} ${contact.value.lastname || ''}`.trim()
  }
  if (company.value) {
    return company.value.name || '-'
  }
  return '-'
})

const href = computed(() => {
  if (company.value) return `/partner/${company.value.referenceExterne}`
  if (contact.value) return `/dashboard/contacts/${contact.value.uuid}`
  return null
})
</script>

<template>
  <a v-if="href" :href="href" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-1 hover:opacity-80">
    {{ displayText }}
    <ArrowTopRightOnSquareIcon class="w-3.5 h-3.5 shrink-0 opacity-60" />
  </a>
  <span v-else>{{ displayText }}</span>
</template>

<style scoped></style>
